/** @flow */
import Router from './Router.jsx'

export { createRouter } from './createRouter'
export default Router
